import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  swal,
  Common
} from '../../config/react'
import readXlsxFile from 'read-excel-file'
import exampleSheet from '../../assests/example_sheets/Product_Sheet.xlsx'
import Spinner from '../Spinner'
const ImportProducts = () => {
  const user = useContext(UserContext)
  const history = useHistory()
  const [isForceUpdate, setForceUpdate] = useState(false)
  const validator = useRef(new SimpleReactValidator())
  const [loading, setLoading] = useState(false)
  const [IsInvalidFileType, setIsInvalidFileType] = useState(false)
  const [Inputs, setInputs] = useState({
    excel_sheet: []
  })

  useEffect(() => {
    document.title = Title.ImportExcel
  }, [])

  const uploadExcelFile = (e) => {
    setInputs({ ...Inputs, excel_sheet: e.target.files[0] })
    setForceUpdate(!isForceUpdate)
  }
  // const renderErrors = (errors) => {
  //   return (
  //     <div>
  //       {errors.map((item) => (
  //         <p
  //           className="mb-1"
  //           key={Math.random()}
  //         >
  //           {item.messages}
  //         </p>
  //       ))}
  //     </div>
  //   )
  // }
  const renderSheetErrors = (errors) => {
    return (
      <div>
        {Object.keys(errors).map((item, key) => (
          <p
            className="mb-1"
            key={Math.random()}
          >
            Line- {item + 1}: {errors[item].map(({ messages }) => messages).join(',')}
          </p>
        ))}
      </div>
    )
  }
  const imageErrorMessage = (skuWithoutBaseImage, skuWithoutVideo) => {
    return (
      <div>
        {skuWithoutBaseImage.length > 0 && (
          <>
            <b>Base image not uploaded for below SKU:</b>
            {skuWithoutBaseImage.map((sku) => (
              <p
                className="mb-1"
                key={Math.random()}
              >
                {sku}
              </p>
            ))}
          </>
        )}
      </div>
    )
  }

  const SubmitForm = () => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const regex = /(?:\.([^.]+))?$/
    const fileExtension = regex.exec(Inputs.excel_sheet.name)[1]
    if (['xlsx', 'xls'].indexOf(fileExtension) < 0) {
      setIsInvalidFileType(true)
      return
    }
    setIsInvalidFileType(false)
    setLoading(true)
    readXlsxFile(Inputs.excel_sheet).then((rows) => {
      const headers = rows[0]
      rows.splice(0, 1)
      const datas = rows
      const excelDatas = []
      if (datas.length < 1) {
        setLoading(false)
        swal({
          title: Messages.oops,
          text: Messages.blankfile,
          icon: 'error',
          buttons: {
            cancel: true,
            confirm: false
          }
        })
        return
      }

      for (let i = 0; i < datas.length; i++) {
        const array = {}
        for (let j = 0; j < datas[i].length; j++) {
          array[headers[j].toLowerCase().replaceAll(' ', '_').replaceAll('-', '_')] = datas[i][j]
        }
        excelDatas.push(array)
      }
      const products = []

      if (excelDatas[0].sku === undefined || excelDatas[0].product_title === undefined) {
        setLoading(false)
        swal({
          title: Messages.oops,
          text: Messages.invalidfile,
          icon: 'error',
          buttons: {
            cancel: true,
            confirm: false
          }
        })
        return
      }
      excelDatas.map((item) => {
        if (item.parent_sku === null) {
          const categories =
            item.category !== null && item.category.indexOf('|') >= 0
              ? item.category.split('|')
              : [item.category]
          const subCategories =
            item.sub_category !== null && item.sub_category.indexOf('|') >= 0
              ? item.sub_category.split('|')
              : [item.sub_category]

          var finalCategories = []
          categories.forEach((element) => {
            if (finalCategories.indexOf(element) < 0) {
              finalCategories.push(element)
            }
          })
          const customAttributes =
            item.attributes !== null && item.attributes.indexOf('|') >= 0
              ? item.attributes.split('|')
              : null
          // const metalQuality = JSON.parse(products[item.parent_sku].stone_clarity)

          const attributesArr = []
          if (customAttributes !== '' && customAttributes !== null && customAttributes.length > 0)
            customAttributes.forEach((element) => {
              const attribute = element.split(':')
              attributesArr.push({ title: attribute[0].trim(), value: attribute[1].trim() })
            })

          products[item.sku] = {
            sku: item.sku,
            name: item.product_title,
            weight: item.weight,
            weight_unit: item.weight_unit,
            is_configured: 1,
            description: item.description,
            short_description: item.description,
            is_readytoship: item.stock > 0 ? 1 : 0,
            is_sold: 0,
            meta_description: item.meta_description,
            meta_keywords: item.meta_keywords,
            meta_title: item.meta_title,
            qty: item.stock > 0 ? item.stock : 0,
            price: item.price,
            status: 1,
            Userid: user.id,
            category: finalCategories.join('|'),
            sub_category: subCategories.join('|'),
            side_diamonds_size: item.side_diamonds_size,
            side_diamonds_pieces: item.side_diamonds_pieces,
            side_diamonds_weight: item.side_diamonds_weight,
            side_diamonds_weight_unit: item.side_diamonds_weight_unit,
            parent_sku: null,
            related_products: item.related_skus !== null ? item.related_skus : '',
            attribute_set: item.attribute_set,
            options: [],
            can_be_set_with_shape: item.can_be_set_with_shape,
            can_be_set_with_carat: item.can_be_set_with_carat,
            attributes: attributesArr,
            is_gift_card:
              item.is_gift_card !== null &&
              item.is_gift_card !== '' &&
              item.is_gift_card.toLowerCase() === 'yes'
                ? 1
                : 0
          }
        } else {
          if (products[item.parent_sku] !== undefined) {
            const productAttributeOptions = []
            let attributes = []
            if (item.options !== null && item.options !== '') {
              attributes = item.options.split('|')
              attributes.map((item) => {
                const explodedOption = item.split(':')
                productAttributeOptions.push({
                  option_name: explodedOption[0],
                  option_value: explodedOption[1]
                })
                return true
              })
            }
            products[item.sku] = {
              sku: item.sku,
              model_number: item.model_number,
              name: products[item.parent_sku].name,
              weight: products[item.parent_sku].weight,
              weight_unit: products[item.parent_sku].weight_unit,
              is_configured: 0,
              description: products[item.parent_sku].description,
              short_description: products[item.parent_sku].short_description,
              is_readytoship: item.stock > 0 ? 1 : 0,
              is_sold: 0,
              meta_description: products[item.parent_sku].meta_description,
              meta_keywords: products[item.parent_sku].meta_keywords,
              meta_title: products[item.parent_sku].meta_title,
              qty: 1,
              price: item.price,
              status: 1,
              Userid: user.id,
              category: products[item.parent_sku].category,
              sub_category: products[item.parent_sku].sub_category,
              side_diamonds_size: products[item.parent_sku].side_diamonds_size,
              side_diamonds_pieces: products[item.parent_sku].side_diamonds_pieces,
              side_diamonds_weight: products[item.parent_sku].side_diamonds_weight,
              side_diamonds_weight_unit: products[item.parent_sku].side_diamonds_weight_unit,
              size: products[item.parent_sku].size,
              parent_sku: item.parent_sku,
              related_products: products[item.parent_sku].related_products,
              attribute_set: products[item.parent_sku].attribute_set,
              options: productAttributeOptions,
              attributes: products[item.parent_sku].attributes,
              can_be_set_with_shape: products[item.parent_sku].can_be_set_with_shape,
              can_be_set_with_carat: products[item.parent_sku].can_be_set_with_carat,
              is_gift_card: products[item.parent_sku].is_gift_card
            }
            // }
          }
        }
        return true
      })
      const errorMessages = []
      excelDatas.map((item, index) => {
        // Sheet required fields validation start
        if (item.sku === '' || item.sku === null) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredSku })
        }
        if (
          item.product_title !== '' &&
          item.product_title !== null &&
          (item.attribute_set === '' || item.attribute_set === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredAttributeSet })
        }
        if (
          (item.product_title === '' || item.product_title === null) &&
          (item.parent_sku === '' || item.parent_sku === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredParentSku })
        }
        if (
          item.attribute_set !== '' &&
          item.attribute_set !== null &&
          (item.product_title === '' || item.product_title === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredProductTitle })
        }
        if (
          item.product_title !== '' &&
          item.product_title !== null &&
          (item.category === '' || item.category === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredCategory })
        }
        // if (
        //   item.parent_sku !== '' &&
        //   item.parent_sku !== null &&
        //   (item.weight === '' || item.weight === null)
        // ) {
        //   errorMessages.push({ line: index + 1, messages: Messages.RequiredWeight })
        // }
        if (
          item.parent_sku !== '' &&
          item.parent_sku !== null &&
          (item.price === '' || item.price === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredPrice })
        } else if (
          item.parent_sku !== '' &&
          item.parent_sku !== null &&
          isNaN(parseInt(item.price))
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.InvalidPrice })
        }

        if (
          item.option1_name !== '' &&
          item.option1_name !== null &&
          (item.option1_value === '' || item.option1_value === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredOption1Value })
        }
        if (
          item.option2_name !== '' &&
          item.option2_name !== null &&
          (item.option2_value === '' || item.option2_value === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredOption2Value })
        }
        if (
          item.option3_name !== '' &&
          item.option3_name !== null &&
          (item.option3_value === '' || item.option3_value === null)
        ) {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredOption3Value })
        }
        if (item.can_be_set_with_shape !== '' && item.can_be_set_with_carat === '') {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredCanBeSetCarat })
        }
        if (item.can_be_set_with_shape === '' && item.can_be_set_with_carat !== '') {
          errorMessages.push({ line: index + 1, messages: Messages.RequiredCanBeSetShape })
        }
        // Sheet required fields validation end
        if (item.parent_sku === null) {
          const categories =
            item.category !== null && item.category.indexOf('|') >= 0
              ? item.category.split('|')
              : [item.category]
          const subCategories =
            item.sub_category !== null && item.sub_category.indexOf('|') >= 0
              ? item.sub_category.split('|')
              : [item.sub_category]

          var finalCategories = []
          categories.forEach((element) => {
            if (finalCategories.indexOf(element) < 0) {
              finalCategories.push(element)
            }
          })
          const attributes =
            item.attributes !== null && item.attributes.indexOf('|') >= 0
              ? item.attributes.split('|')
              : null
          // const metalQuality = JSON.parse(products[item.parent_sku].stone_clarity)

          const attributesArr = []
          if (attributes !== '' && attributes !== null && attributes.length > 0)
            attributes.forEach((element) => {
              const attribute = element.split(':')
              attributesArr.push({ title: attribute[0].trim(), value: attribute[1].trim() })
            })
          products[item.sku] = {
            sku: item.sku,
            name: item.product_title,
            weight: item.weight,
            weight_unit: item.weight_unit,
            is_configured: 1,
            description: item.description,
            short_description: item.description,
            is_readytoship: item.stock > 0 ? 1 : 0,
            is_sold: 0,
            meta_description: item.meta_description,
            meta_keywords: item.meta_keywords,
            meta_title: item.meta_title,
            qty: item.stock > 0 ? item.stock : 0,
            price: item.price,
            status: 1,
            Userid: user.id,
            category: finalCategories.join('|'),
            sub_category: subCategories.join('|'),
            side_diamonds_size: item.side_diamonds_size,
            side_diamonds_pieces: item.side_diamonds_pieces,
            side_diamonds_weight: item.side_diamonds_weight,
            side_diamonds_weight_unit: item.side_diamonds_weight_unit,
            parent_sku: null,
            related_products: item.related_skus !== null ? item.related_skus : '',
            total_colors: 0,
            attribute_set: item.attribute_set,
            can_be_set_with_shape: item.can_be_set_with_shape,
            can_be_set_with_carat: item.can_be_set_with_carat,
            attributes: attributesArr,
            is_gift_card: item.is_gift_card
          }
        } else {
          if (products[item.parent_sku] !== undefined) {
            const customAttributes =
              item.attributes !== null && item.attributes.indexOf('|') >= 0
                ? item.attributes.split('|')
                : null
            const attributesArr = []
            if (customAttributes !== '' && customAttributes !== null && customAttributes.length > 0)
              customAttributes.forEach((element) => {
                const attribute = element.split(':')
                attributesArr.push({ title: attribute[0].trim(), value: attribute[1].trim() })
              })

            const productAttributeOptions = []
            let attributes = []
            if (item.options !== null && item.options !== '') {
              attributes = item.options.split('|')
              attributes.map((item) => {
                const explodedOption = item.split(':')
                productAttributeOptions.push({
                  option_name: explodedOption[0],
                  option_value: explodedOption[1]
                })
                return true
              })
            }
            // if (item.sku !== '') {
            products[item.sku] = {
              sku: item.sku,
              model_number: item.model_number,
              name: products[item.parent_sku].name,
              weight: products[item.parent_sku].weight,
              weight_unit: products[item.parent_sku].weight_unit,
              stone_weight: products[item.parent_sku].stone_weight,
              stone_pieces: products[item.parent_sku].stone_pieces,
              is_configured: 0,
              description: products[item.parent_sku].description,
              short_description: products[item.parent_sku].short_description,
              is_readytoship: item.stock > 0 ? 1 : 0,
              is_sold: 0,
              meta_description: products[item.parent_sku].meta_description,
              meta_keywords: products[item.parent_sku].meta_keywords,
              meta_title: products[item.parent_sku].meta_title,
              qty: item.stock > 0 ? item.stock : 0,
              price: item.price,
              status: 1,
              Userid: user.id,
              category: products[item.parent_sku].category,
              sub_category: products[item.parent_sku].sub_category,
              side_diamonds_size: products[item.parent_sku].side_diamonds_size,
              side_diamonds_pieces: products[item.parent_sku].side_diamonds_pieces,
              side_diamonds_weight: products[item.parent_sku].side_diamonds_weight,
              side_diamonds_weight_unit: products[item.parent_sku].side_diamonds_weight_unit,
              size: products[item.parent_sku].size,
              parent_sku: item.parent_sku,
              related_products: products[item.parent_sku].related_products,
              total_colors: 0,
              attribute_set: products[item.parent_sku].attribute_set,
              options: productAttributeOptions,
              attributes: products[item.parent_sku].attributes,
              can_be_set_with_shape: products[item.parent_sku].can_be_set_with_shape,
              can_be_set_with_carat: products[item.parent_sku].can_be_set_with_carat,
              is_gift_card: products[item.parent_sku].is_gift_card
            }
            // }
          }
        }
        return true
      })
      // if (errorMessages.length >= 9999999) {
      // temp condition because work is in progress
      if (errorMessages.length > 0) {
        // if (1 === 2) {
        setLoading(false)
        const messages = Common.groupBy(errorMessages, 'line')
        swal({
          title: Messages.oops,
          content: renderSheetErrors(messages),
          icon: 'error',
          buttons: {
            cancel: true,
            confirm: false
          }
        })
      } else {
        const finalArray = []
        Object.values(products).map((item) => {
          if (item.parent_sku === null || item.parent_sku === '') {
            const childProducts = Object.values(products).filter(
              (childItem) => childItem.parent_sku === item.sku
            )
            products[item.sku].child_skus =
              childProducts.length > 0 ? childProducts.map((item) => item.sku).join(',') : ''
          }
          return true
        })
        for (const key in products) {
          finalArray.push(products[key])
        }
        if (finalArray.length > 0) {
          HttpService.postApi(API.ImportProducts, finalArray).then((response) => {
            // console.log(response);
            // return
            setLoading(false)
            if (response.data.message) {
              toast.warning(response.data.message)
              setForceUpdate(!isForceUpdate)
              return
            }
            if (response.data.result.sku_without_images !== undefined) {
              const skuWithoutBaseImage = response.data.result.sku_without_images
              const skuWithoutVideo = response.data.result.sku_without_video
              if (skuWithoutBaseImage.length > 0 || skuWithoutVideo.length > 0) {
                swal({
                  title: Messages.oops,
                  content: imageErrorMessage(skuWithoutBaseImage, skuWithoutVideo),
                  icon: 'error',
                  buttons: {
                    cancel: true,
                    confirm: false
                  }
                })
              }
            } else {
              if (response.data.result[0].length > 0 && !response.data.result[0][0].result) {
                const errors = Common.groupBy(response.data.result[0], 'line')
                console.log(errors)
                swal({
                  title: Messages.oops,
                  content: renderSheetErrors(errors),
                  html: true,
                  icon: 'error',
                  buttons: {
                    cancel: true,
                    confirm: false
                  }
                })
              } else {
                toast.success(Messages.RecordAdded)
                setForceUpdate(!isForceUpdate)
                history.push('/products')
              }
            }
          })
        } else {
          setLoading(false)
          swal({
            title: Messages.oops,
            text: Messages.blankfile,
            icon: 'error',
            buttons: {
              cancel: true,
              confirm: false
            }
          })
        }
      }
    })
  }

  return loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0"> {Title.ImportExcel} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Upload Excel</label>
                      <input
                        type="file"
                        name="excel_sheet"
                        onChange={uploadExcelFile}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style={{ display: 'block' }}
                        className="form-control"
                      />
                      <label
                        className="mt-1"
                        style={{
                          'font-size': '12px'
                        }}
                      >
                        (Only .xlsx, .xls file type is allowed)
                      </label>
                      {validator.current.message('Sheet', Inputs.excel_sheet, 'required', {
                        className: 'error'
                      })}
                      {IsInvalidFileType && (
                        <div className="error">{Messages.formatnotsupport}</div>
                      )}
                      <a
                        href={exampleSheet}
                        className="float-right"
                        style={{
                          'font-size': '12px',
                          color: '#000000d4',
                          'text-decoration': 'underline'
                        }}
                        download
                      >
                        Example Sheet
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    {/* <button type="button" onClick={SubmitForm} className="btn btn-primary mr-2"> Check Images </button> */}
                    <button
                      className="btn btn-light mr-3"
                      type="button"
                      onClick={SubmitForm}
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/products"
                      className="btn btn-light"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImportProducts
